/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import BLUETOOTH_STATUS from 'constants/bluetooth';
export var DeviceSetupWelcome = function DeviceSetupWelcome(_ref) {
  var updateDevice = _ref.updateDevice;
  return React.createElement("div", {
    className: "modal__device-setup__welcome"
  }, React.createElement("div", {
    className: "modal__device-setup__top"
  }, React.createElement(FormattedMessage, {
    id: "device.welcome-header",
    defaultMessage: "Welcome to ClassPass Live!",
    tagName: "h3"
  }), React.createElement(FormattedMessage, {
    id: "device.welcome-intro",
    defaultMessage: "Let\u2019s get your profile and equipment set up \u2013 it should only take a few minutes.",
    tagName: "p"
  })), React.createElement("div", {
    className: "modal__device-setup__content"
  }, React.createElement("img", {
    src: require('../../../static/img/device-setup-welcome.svg'),
    alt: "Welcome",
    className: "modal__device-setup__welcome-img m+"
  }), React.createElement("button", {
    className: "bt bt--primary bt--width-md mv",
    onClick: function onClick() {
      return updateDevice({
        status: BLUETOOTH_STATUS.INPUT_INFO
      });
    },
    key: "device.welcome.button"
  }, "Setup your profile")));
};
DeviceSetupWelcome.propTypes = {
  updateDevice: PropTypes.func
};